import useTranslation from 'next-translate/useTranslation'

import {
  IconBucketSecurity,
  IconCompatibility,
  IconLocation,
  IconScaling,
} from '@/res/icons'
import { NAMESPACE_S3_BUCKET } from '@/res/namespaces'

const Characteristics: React.FC = () => {
  const { t } = useTranslation(NAMESPACE_S3_BUCKET)

  return (
    <>
      <div className="characteristics container pb-16 lg:pb-20">
        <h5 className="text-[#242F3C] font-semibold text-xl sm:text-[28px] lg:text-4xl mb-5">
          {t('characteristics')}
        </h5>
        <div className="min-h-[170px] card rounded-2xl py-6 px-4 xl:p-8 flex flex-col justify-between md:flex-row">
          <div className="flex flex-col justify-between md:mr-2.5">
            <div className="flex gap-2 md:gap-2.5 xl:gap-[15px] items-center mb-2.5 md:mb-0">
              <IconLocation className="w-[40px]" />
              <p className="text-[#7B8794] text-base md:text-tiny xl:text-lg">
                {t('charac1')}
              </p>
            </div>
            <div className="flex gap-2 md:gap-2.5 xl:gap-[15px] items-center mb-2.5 md:mb-0">
              <IconCompatibility className="w-[40px]" />
              <p className="text-[#7B8794] text-base md:text-tiny xl:text-lg">
                {t('charac2')}
              </p>
            </div>
          </div>
          <div className="flex flex-col justify-between">
            <div className="flex gap-2 md:gap-2.5 xl:gap-[15px] items-center mb-2.5 md:mb-0">
              <IconBucketSecurity className="w-[40px]" />
              <p className="text-[#7B8794] text-base md:text-tiny xl:text-lg">
                {t('charac3')}
              </p>
            </div>
            <div className="flex gap-2 md:gap-2.5 xl:gap-[15px] items-center mb-2.5 md:mb-0">
              <IconScaling className="w-[40px]" />
              <p className="text-[#7B8794] text-base md:text-tiny xl:text-lg">
                {t('charac4')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Characteristics
